import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { routes } from '../../../consts'
import Actions from '../../../actions'

const PaymentCancel = () => {
  const dispatch = useDispatch()
  const selectedPlan = useSelector(state => state.payment.selectedPlan)

  useEffect(() => {
    dispatch(Actions.createAction(Actions.REDIRECT_TO_PAYMENT_CANCEL))
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        eventName: 'payment_cancel_web',
        data: { selectedPlan },
      })
    )
  }, [])

  return null
}

export default PaymentCancel
